// extracted by mini-css-extract-plugin
module.exports = {"exception":"exception--2MjaQ","imgBlock":"imgBlock--3C2qT","imgEle":"imgEle--2Z0IG","content":"content--DGjuP","desc":"desc--3-qfg","actions":"actions--3HGa5"};